module.exports = __webpack_public_path__ + "static/media/Forest.5737a985.svg";